import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { extractLocaleFromPath, detectBrowserLanguage } from '../utils/i18n';

// Import translations
import enTranslations from './locales/en.json';
import plTranslations from './locales/pl.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  pl: {
    translation: plTranslations,
  },
};

// Create language detector instance
const languageDetector = new LanguageDetector();

// Custom path detector that extracts locale from TanStack Router paths
const pathDetector = {
  name: 'path',
  lookup(): string | undefined {
    return extractLocaleFromPath(window.location.pathname);
  },
  cacheUserLanguage(): void {
    // We don't want to cache from path detection
  },
};

// Custom browser detector with fallback to our supported languages
const browserDetector = {
  name: 'browser',
  lookup(): string {
    return detectBrowserLanguage();
  },
  cacheUserLanguage(): void {
    // We don't cache browser detection
  },
};

// Add custom detectors to the language detector instance
languageDetector.addDetector(pathDetector);
languageDetector.addDetector(browserDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: undefined, // Let the detector determine the language
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      // Path detection first, then localStorage, then our custom browser detector
      order: ['path', 'localStorage', 'browser'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
